import React, { Component, Fragment } from "react";
import DcSelector from "./DcSelector";
import HotModIndicator from "./HotModIndicator";
import Calendar from "../common/Calendar";
import StatusModal from "../common/StatusModal";
class CustomInput extends Component {
  state = {
    item: {
      node: "",
      type: "",
      value: "",
      intemName: "",
      autoFocus: false,
      hotMod: true
    },
    label: { value: "", size: "", maxWidth: "" },
    onChangeHandler: undefined,
    readOnly: undefined,
    size: "",
    span: undefined
  };
  constructor(props) {
    super(props);
    // this.item;
    this.storedValue = "";
    this.injectedValue = "";
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.item.item.value === prevState.item.value) {
      return {
        item: nextProps.item.item,
        label: nextProps.item.label,
        readOnly: nextProps.item.readOnly,
        size: nextProps.item.size,
        span: nextProps.item.span
      };
    } else {
      return null;
    }
  }
  onCheck = value => {
    if (value !== "N") {
      value = " ";
    }
    this.setState({
      onChangeHandler: this.state.item.value === value ? undefined : value
    });
    this.props.handleNewData(this.state.item.intemName, value);
  };
  onClick = value => {
    if (this.props.item.item.onClick) {
      this.props.functions[this.props.item.item.onClick]();
    }
  };
  onChange = val => {
    if (
      this.props.item.item.maxNumber &&
      parseFloat(val) > parseFloat(this.props.item.item.maxNumber)
    ) {
      val = this.props.item.item.maxNumber;
    }
    if (this.props.item.item.forceCaps) {
      val = val.toUpperCase();
    }
    var maxLength = this.props.item.item.maxLength;
    var filter = this.props.item.item.filter
      ? this.props.item.item.filter
      : false;
    var regex = new RegExp(filter, "g");
    val = filter ? val.replace(regex, "") : val;
    maxLength && val.length > maxLength ? (val = val.substr(1)) : (val = val);
    if (parseInt(val, 10).toString().length <= 9) {
      var value = this.props.item.item.zeroPadding
        ? this.numberToZeroPadded(val, this.props.item.item.zeroPadding)
        : val;

      if (this.state.item.type === "number") {
        if (value.match(/[^\d]/g, "")) {
          // this.setErrorMessage("Only Numeric");
          value = value.replace(/[^\d]/g, "");
        }
      }
      this.setState({
        // eslint-disable-next-line
        onChangeHandler: this.state.item.value === value ? undefined : value
      });
      this.props.handleNewData(this.state.item.intemName, value);
      if (this.props.item.item.onChange) {
        this.props.functions[this.props.item.item.onChange]();
      }
    }
  };
  onBlur = value => {
    if (value === "") {
      this.setState({ onChangeHandler: undefined });
    }
    this.props.handleNewData(this.state.item.intemName, value);
    if (this.props.item.item.onBlur) {
      this.props.functions[this.props.item.item.onBlur](
        this.state.item.intemName,
        value
      );
    }
  };
  onFocus = value => {
    if (this.props.item.item.onFocus) {
      this.props.functions[this.props.item.item.onFocus](
        this.state.item.intemName,
        value
      );
    }
  };
  calculateChUnit = x => {
    if (x) {
      const formattedValue = x
        .toString()
        .split(" ")
        .join("  ");
      const r = "calc( 15px + " + formattedValue.length + "ch)";
      return r;
    }
  };
  numberToZeroPadded = (num, z) => {
    typeof num !== "number" ? (num = num.replace(/[^\d]/g, "")) : (num = num);
    const abs = Math.abs(num);
    if (abs !== 0) {
      var no = parseInt(num, 10);
      num = no.toString();
      var zeroNo = z - num.length;
      var zeros = "";
      for (let i = 0; i < zeroNo; i++) {
        zeros = "0" + zeros;
      }
      return zeros + no;
    } else {
      return 0;
    }
  };

  selectDate = x => {
    this.props.functions.handeOpenModal(
      "success",
      "Input...",
      <Calendar getDate={this.setDate} itemName={x} />,
      "format_list_bulleted",
      "Close"
    );
  };
  setDate = (date, itemName) => {
    const formattedDate =
      date.getFullYear() +
      "-" +
      this.numberToZeroPadded(date.getMonth() + 1, 2) +
      "-" +
      this.numberToZeroPadded(date.getDate(), 2);

    if (this.props.item.item.onChangeDate) {
      const isValid = this.props.functions[this.props.item.item.onChangeDate](
        formattedDate
      );
      if (isValid) {
        this.setState({
          // eslint-disable-next-line
          onChangeHandler:
            this.state.item.value == formattedDate ? undefined : formattedDate
        });
        // date = Tue Apr 16 2019 00:00:00 GMT-0500 (Central Daylight Time)
        this.props.handleNewData(formattedDate);
      }
    } else {
      this.setState({
        // eslint-disable-next-line
        onChangeHandler:
          this.state.item.value == formattedDate ? undefined : formattedDate
      });
      // date = Tue Apr 16 2019 00:00:00 GMT-0500 (Central Daylight Time)
      this.props.handleNewData(itemName, formattedDate);
    }

    this.props.functions.closeModal();
  };

  componentDidUpdate() {
    var currentValue = this.state.item.value;
    if (currentValue !== this.storedValue) {
      this.setState({ onChangeHandler: undefined });
      this.storedValue = currentValue;
    }

    if (
      this.state.item.injectedValue &&
      this.state.item.injectedValue !== this.injectedValue
    ) {
      this.injectedValue = this.state.item.injectedValue;
      if (typeof this.injectedValue === "object") {
        this.setState({ onChangeHandler: this.injectedValue[0] });
      } else {
        this.setState({ onChangeHandler: this.injectedValue });
      }
    }
  }
  render() {
    return (
      <Fragment>
        <div
          className={`custom-input-wrapper with-hotmod`}
          style={{
            minWidth: this.props.minWidth ? this.props.minWidth : "unset",
            width: this.props.size,
            justifyContent:
              this.state.item.type === "checkbox" ? "center" : "unset"
          }}
        >
          {this.state.item.node === "input" &&
          (this.state.item.type === "string" ||
            this.state.item.type === "number") ? (
            <Fragment>
              {this.state.label && !this.state.item.noLabel ? (
                <span
                  className="custom-input-label-number-string"
                  style={{
                    fontSize: this.state.label.fontSize,
                    flex: this.state.label.size
                      ? "0 0 " + this.state.label.size
                      : 1,
                    maxWidth: this.state.label.maxWidth,
                    justifyContent: this.state.label.align
                      ? this.state.label.align
                      : "flex-end",
                    opacity: this.state.item.placeHolder ? 0 : 1,
                    borderRadius: this.state.item.noInput
                      ? "0.25rem"
                      : "0.25rem 0 0 0.25rem"
                  }}
                >
                  {this.state.label.value}
                </span>
              ) : null}

              {this.state.span ? (
                <div
                  className="custom-input-span-number-string"
                  style={{
                    fontSize: this.state.span.fontSize
                      ? this.state.span.fontSize
                      : "unset"
                  }}
                >
                  {this.state.span.value}
                </div>
              ) : null}

              {this.state.item.noInput ? null : (
                <input
                  autoFocus={this.state.item.autoFocus}
                  disabled={this.state.readOnly}
                  className="no-arrows custom-input-number-string"
                  // checked={this.state.item.checked}
                  type="string"
                  onFocus={e => this.onFocus(e.target.value)}
                  onBlur={e => this.onBlur(e.target.value)}
                  style={
                    this.state.item.noLabel
                      ? { borderRadius: "0.25rem", padding: "9px 5px" }
                      : {
                          width: this.state.label.size
                            ? "100%"
                            : this.calculateChUnit(this.state.item.value)
                        }
                  }
                  value={
                    this.state.onChangeHandler !== undefined
                      ? this.state.item.decimals
                        ? parseInt(this.state.onChangeHandler).toFixed(
                            this.state.item.decimals
                          )
                        : this.state.onChangeHandler
                      : this.state.item.decimals
                      ? parseInt(this.state.item.value).toFixed(
                          this.state.item.decimals
                        )
                      : this.state.item.value
                  }
                  onChange={e => this.onChange(e.target.value)}
                />
              )}
              {this.state.item.hotMod !== false ? (
                <div
                  className={`hotmod ${
                    this.state.onChangeHandler &&
                    this.state.onChangeHandler !== this.state.item.value
                      ? null
                      : "off"
                  }`}
                >
                  <HotModIndicator />
                </div>
              ) : null}
            </Fragment>
          ) : this.state.item.node === "input" &&
            this.state.item.type === "checkbox" ? (
            <Fragment>
              <label
                htmlFor={this.state.item.intemName}
                style={{
                  display: "flex",
                  padding: ".375rem ",
                  margin: "0",
                  color: "#495057",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  maxWidth: this.state.label.maxWidth,
                  cursor: this.state.readOnly ? "unset" : "pointer"
                }}
              >
                {this.state.label.value}
              </label>
              {this.state.span ? (
                <div
                  style={{
                    display: "flex",
                    color: "#495057",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    padding: "0 5px"
                  }}
                >
                  {this.state.span.value}
                </div>
              ) : null}

              <input
                disabled={this.state.readOnly}
                type={this.state.item.type}
                id={this.state.item.intemName}
                style={{
                  position: "absolute",
                  visibility: "hidden"
                }}
                checked={
                  this.state.onChangeHandler !== undefined
                    ? this.state.onChangeHandler === "N"
                      ? false
                      : true
                    : this.state.item.value === "N"
                    ? false
                    : true
                }
                onChange={e =>
                  this.onCheck(e.target.checked === false ? "N" : " ")
                }
              />
              <label
                htmlFor={this.state.item.intemName}
                style={{
                  border: this.state.readOnly
                    ? "2px solid #ced4da"
                    : "2px solid #495057",
                  margin: "0",
                  height: "20px",
                  width: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "3px",
                  // color: this.state.readOnly ? "#ced4da" : "unset",
                  background: this.state.readOnly ? "#ced4da" : "unset",
                  cursor: this.state.readOnly ? "unset" : "pointer"
                }}
              >
                <i
                  className="material-icons"
                  style={{
                    fontSize: "100%",
                    transition: "all ease-in-out .3s",
                    fontWeight: "bolder",
                    visibility:
                      this.state.onChangeHandler !== undefined
                        ? this.state.onChangeHandler === "N"
                          ? "hidden"
                          : "visible"
                        : this.state.item.value === " "
                        ? "visible"
                        : "hidden",
                    opacity: this.state.readOnly ? ".35" : 1,
                    // this.state.onChangeHandler !== undefined
                    //   ? this.state.onChangeHandler
                    //     ? 0
                    //     : 1
                    //   : this.state.item.checked
                    //   ? 0
                    //   : 1,
                    transform:
                      this.state.onChangeHandler !== undefined
                        ? this.state.onChangeHandler === "N"
                          ? "scale(.5)"
                          : "scale(1)"
                        : this.state.item.value === "N"
                        ? "scale(.5)"
                        : "scale(1)"
                  }}
                >
                  check
                </i>
              </label>

              <div
                className={`hotmod ${
                  this.state.onChangeHandler !== undefined ? null : "off"
                }`}
                style={{ position: "relative" }}
              >
                <HotModIndicator />
              </div>
            </Fragment>
          ) : null}
          {this.state.item.node === "DCSelector" ? (
            <Fragment>
              <label
                style={{
                  flex: this.state.label.size
                    ? "0 0 " + this.state.label.size
                    : 1,
                  maxWidth: this.state.label.maxWidth
                }}
                className={"DCSelector-label"}
              >
                {this.state.label.value}
              </label>
              <div className="DCSelector">
                <DcSelector
                  onChangeHandler={this.onChange}
                  setErrorMsg={this.props.functions.setErrorMessage}
                  setSuccessMsg={this.props.functions.setSuccessMessage}
                  whsesForItem={this.state.item.value}
                  singleSelect={this.state.item.singleSelect}
                />
              </div>
            </Fragment>
          ) : null}
          {this.state.item.node === "datePicker" ? (
            <Fragment>
              <label
                className={"DCSelector-label"}
                id={this.state.item.name}
                style={{
                  flex: this.state.label.size
                    ? "0 0 " + this.state.label.size
                    : 1,
                  maxWidth: this.state.label.maxWidth
                }}
              >
                {this.state.label.value}
              </label>
              <div
                autoFocus={this.state.item.autoFocus}
                disabled={this.state.readOnly}
                className="custom-input-number-string"
                style={{
                  width: this.state.label.size
                    ? "100%"
                    : this.calculateChUnit(this.state.item.value)
                }}
                onClick={e => this.selectDate(this.state.item.intemName)}
              >
                {this.state.onChangeHandler !== undefined
                  ? this.state.onChangeHandler
                  : this.state.item.value}
              </div>
            </Fragment>
          ) : null}

          {this.state.item.node === "onlySpan" ? (
            <Fragment>
              <div
                className="custom-input-span-number-string"
                style={{
                  justifyContent: this.state.span.alignment,
                  width: this.state.span.size
                }}
              >
                {this.state.span.value}
              </div>
            </Fragment>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default CustomInput;
